import { QueryClient, UseQueryOptions, useMutation, useQuery, useQueryClient } from 'react-query'
import { getAIAgentOnboardingStatus, completeAIAgentTasks } from 'features/onboarding-checklist/api/onboardingChecklist'
import { OnboardingChecklistProps } from 'features/onboarding-checklist/types'

export const aiAgentTasksQueryKeys = {
  all: ['aiAgentTasks'] as const,
  tasks: ['aiAgentTasks', 'ai-agent'],
  task: (id: string) => ['aiAgentTasks', 'ai-agent', id]
}

const handleAIAgentTasksCallback = (data: OnboardingChecklistProps, queryClient?: QueryClient) => {
  const { completed } = data || {}
  if (queryClient && completed) {
    queryClient.invalidateQueries(aiAgentTasksQueryKeys.tasks)
  }
}

const aiAgentTasksQuery: UseQueryOptions<OnboardingChecklistProps, Error> = {
  queryKey: aiAgentTasksQueryKeys.tasks,
  queryFn: () => getAIAgentOnboardingStatus(),
  staleTime: Infinity,
  onSuccess: handleAIAgentTasksCallback
}

export function useAIAgentCompleteTasksMutation(onError) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: completeAIAgentTasks,
    onSuccess: (data) => handleAIAgentTasksCallback(data, queryClient),
    onError
  })
}

export function useAIAgentTasksQuery() {
  const { data: response, isLoading } = useQuery(aiAgentTasksQuery)
  const { tasks, completed } = response || {}

  return {
    tasks,
    completed,
    isLoading
  }
}
